import React, { useMemo } from 'react';

import clsx from 'clsx';
import BiDashboardHeader from 'components/bi-dashboard/BiDashboardHeader';
import BiDashboardTable from 'components/bi-dashboard/BiDashboardTable';
import FiltersPanel from 'components/bi-dashboard/FiltersPanel';
import { BiDashboardPageStore, BiDashboardPageStoreContext } from 'store/pages/bi-groups-dashboard/pageStore';
import RowActionModals from 'components/bi-dashboard/RowActionModals';
import { createStyles } from '../../globalStyles';

const BiDashboardPage: React.FC = () => {
  const pageStore = useMemo(() => new BiDashboardPageStore(), []);
  const classes = createStyles();
  return (
    <BiDashboardPageStoreContext.Provider value={pageStore}>
      <div className={clsx(classes.pageWrapper, classes.widePageWrapper)}>
        <BiDashboardHeader />
        <FiltersPanel />
        <RowActionModals />
        <BiDashboardTable />
      </div>
    </BiDashboardPageStoreContext.Provider>
  );
};

export default BiDashboardPage;
